import type { FaireProductEntity } from "../../entity_types/product";

export const p_3gyrb2d7gh: FaireProductEntity = {
  token: "p_3gyrb2d7gh",
  type: "product",
  name: "CWDMD03195_MID-LENGTH SLEEVE V-NECK RUFFLED HEM DRESS",
  brandToken: "b_gd86yguu29",
  brandName: "NINEXIS",
  imageUrl:
    "https://cdn.faire.com/fastly/7a7bffcc68eb5519498706a60dfce93b01544dcc89dd6a7023dbe7795539f64a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c9184f5f29e62804490624cacb912b11f9180efd867d359699bee8b155242a8.jpeg",
    "https://cdn.faire.com/fastly/a58d6dd729539280e9d6b02c4d93e95e941e218903816f023cb4ac97311d8990.jpeg",
    "https://cdn.faire.com/fastly/5797342604baeecdfe4d1804cdf0209158da30940ec4b2f3f91c9e1f290b835b.jpeg",
    "https://cdn.faire.com/fastly/89124a5b2a3689342eb5ed3eadb1b88f9f8cb5e19da6947dc9e9e71b79296701.jpeg",
    "https://cdn.faire.com/fastly/80121e134fcba97b93c688b933dde528c4a57157dad0249f15558f6744fa0289.png",
    "https://cdn.faire.com/fastly/3c1ddc0cbe2d27c5f9e97a6f885e0d8eb969f867a7b8e2152e9657e8df40033d.jpeg",
  ],
  priceDollars: 12.88,
  description:
    "MID-LENGTH SLEEVE V-NECK RUFFLED HEM DRESS\n95% POLYESTER,5%ELASTANE\nSIZES : S,M,L,XL,XXL,XXXL\nMADE IN CHINA\n\nDRESS,WOMENDRESS,ASYMMETRIC,BOHEMIAN,MAXI DRESSES,BEACH DRESSES,SUN PROTECTION,HOLIDAY PARTIES,BODYCON DRESS,WRAP DRESS,WEDDING GUEST DRESS,OFFICE DRESS,COCKTAIL PARTY DRESS,FLORAL MAXI DRESS FOR BEACH,LACE MATERNITY DRESS WEDDING GUEST,ICE SILK DRESS,HALTER NECK,WRINKLE FREE TRAVEL DRESS,UV PROTECTION SUNDRESS,UGLY SWEATER DRESS,HIGH-WAIST DRESS,WESTERN DRESS,SHORT-SLEEVED DRESS,PATCHWORK DRESS,VEST DRESS, CUTOUT DRESS,CREW-NECK DRESS,LINE-NECK DRESS,V-NECK DRESS,HOMECOMING DRESS, COCKTAIL DRESS,SKI DRESS,SUMMER DRESS,SPRING DRESS,FALL DRESS,WINTER DRESS,PETITE FORMAL DRESS,PLUS SIZE MATERNITY DRESS,MINI DRESS FOR CLUB,DRESS WOMEN SUMMER FLORAL,DRESS GIFT FOR MOM,LACE DRESS,CROCHET KNIT DRESS,VELVET PARTY DRESS,MATCHING FAMILY DRESSES,BLACK FRIDAY DRESS DEALS,CHRISTMAS DRESS GIFTS,DRESS PANTS,  DRESS POCKET,DRESS MATURE WOMEN,FLOOR DRESS",
  tags: [],
  msrpDollars: 25.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:11.825Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
